/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /*
   * Broadcast normally restores focus to the element that opened the cart.
   * Mobile scroll-unlock can occasionally move focus back to <body> after
   * that restoration. Re-check once the close animation has finished, while
   * leaving any intentional user focus movement untouched.
   */
  document.addEventListener('theme:cart-drawer:close', function() {
    var trigger = window.a11y && window.a11y.lastElement;

    window.setTimeout(function() {
      var cartDrawer = document.querySelector('cart-drawer');
      var activeElement = document.activeElement;
      var focusWasLost =
        activeElement === document.body ||
        activeElement === document.documentElement ||
        (cartDrawer && cartDrawer.contains(activeElement));

      if (
        trigger &&
        trigger.isConnected &&
        cartDrawer &&
        !cartDrawer.classList.contains('is-open') &&
        focusWasLost
      ) {
        trigger.focus({preventScroll: true});
      }
    }, 350);
  });

  /*
   * Broadcast conditionally restores the mobile-menu trigger only when its
   * keyboard-modality class is already present. Preserve the invoking control
   * across an Escape close even when the menu was first opened by pointer.
   */
  var mobileMenuEscapeTrigger;
  document.addEventListener(
    'keydown',
    function(event) {
      if (event.key !== 'Escape') {
        return;
      }

      var drawer = document.querySelector('header-drawer.is-open');
      if (!drawer) {
        return;
      }

      mobileMenuEscapeTrigger = document.querySelector(
        '[data-drawer-toggle="hamburger"]'
      );
    },
    true
  );

  /*
   * Product-card alternates should be ready before a fine pointer reaches the
   * card. Preload image alternates only as cards approach the viewport; touch
   * devices keep the alternates inert. Pointer and keyboard intent remain a
   * fallback, and failed alternates return to the visible primary image.
   */
  function deferredHoverForTarget(target) {
    var card =
      target instanceof Element && target.closest('grid-item.product-item');

    return card && card.querySelector('hover-images[data-ar-hover-deferred]');
  }

  function loadDeferredHover(hoverImages) {
    if (
      !hoverImages ||
      hoverImages.dataset.arHoverState ||
      document.documentElement.classList.contains('supports-touch')
    ) {
      return;
    }

    var alternate = hoverImages.querySelector('[data-hover-slide]');
    var mediaTemplate =
      alternate &&
      alternate.querySelector('template[data-ar-hover-media-template]');
    var image =
      alternate && alternate.querySelector('img[data-ar-hover-src]');

    if (mediaTemplate) {
      hoverImages.dataset.arHoverState = 'loaded';
      mediaTemplate.replaceWith(mediaTemplate.content.cloneNode(true));
      return;
    }

    if (!image) {
      return;
    }

    hoverImages.dataset.arHoverState = 'loading';
    image.addEventListener(
      'load',
      function() {
        hoverImages.dataset.arHoverState = 'loaded';
      },
      {once: true}
    );
    image.addEventListener(
      'error',
      function() {
        hoverImages.dataset.arHoverState = 'error';
        hoverImages.hidden = true;
      },
      {once: true}
    );

    if (image.dataset.arHoverSrcset) {
      image.setAttribute('srcset', image.dataset.arHoverSrcset);
    }
    image.setAttribute('src', image.dataset.arHoverSrc);
  }

  var deferredHoverObserver;

  function observeDeferredHovers(root) {
    var fineHover =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (
      !fineHover ||
      document.documentElement.classList.contains('supports-touch') ||
      !('IntersectionObserver' in window)
    ) {
      return;
    }

    if (!deferredHoverObserver) {
      deferredHoverObserver = new IntersectionObserver(
        function(entries) {
          entries.forEach(function(entry) {
            if (!entry.isIntersecting) {
              return;
            }

            deferredHoverObserver.unobserve(entry.target);
            loadDeferredHover(entry.target);
          });
        },
        {rootMargin: '480px 0px'}
      );
    }

    var scope = root && root.querySelectorAll ? root : document;
    var hoverImages = [];

    if (
      scope.matches &&
      scope.matches('hover-images[data-ar-hover-deferred]')
    ) {
      hoverImages.push(scope);
    }

    scope
      .querySelectorAll('hover-images[data-ar-hover-deferred]')
      .forEach(function(item) {
        hoverImages.push(item);
      });

    hoverImages.forEach(function(item) {
      if (
        !item.dataset.arHoverState &&
        item.querySelector('[data-hover-slide] img[data-ar-hover-src]')
      ) {
        deferredHoverObserver.observe(item);
      }
    });
  }

  var deferredHoverObservationScheduled = false;

  function scheduleDeferredHoverObservation() {
    if (deferredHoverObservationScheduled) {
      return;
    }

    deferredHoverObservationScheduled = true;
    var observe = function() {
      deferredHoverObservationScheduled = false;
      observeDeferredHovers(document);
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(observe, {timeout: 500});
    } else {
      window.setTimeout(observe, 0);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      scheduleDeferredHoverObservation();
    });
  } else {
    scheduleDeferredHoverObservation();
  }

  if ('MutationObserver' in window) {
    new MutationObserver(function(records) {
      if (records.some(function(record) { return record.addedNodes.length > 0; })) {
        scheduleDeferredHoverObservation();
      }
    }).observe(document.documentElement, {childList: true, subtree: true});
  }

  document.addEventListener(
    'pointerover',
    function(event) {
      var fineHover =
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      if (event.pointerType === 'touch' || !fineHover) {
        return;
      }

      loadDeferredHover(deferredHoverForTarget(event.target));
    },
    true
  );

  document.addEventListener(
    'focusin',
    function(event) {
      loadDeferredHover(deferredHoverForTarget(event.target));
    },
    true
  );

  document.addEventListener('keyup', function(event) {
    if (event.key !== 'Escape' || !mobileMenuEscapeTrigger) {
      return;
    }

    var trigger = mobileMenuEscapeTrigger;
    mobileMenuEscapeTrigger = null;

    window.setTimeout(function() {
      var drawer = document.querySelector('header-drawer');
      var activeElement = document.activeElement;
      var focusWasLost =
        activeElement === document.body ||
        activeElement === document.documentElement ||
        (drawer && drawer.contains(activeElement));

      if (
        trigger.isConnected &&
        drawer &&
        !drawer.classList.contains('is-open') &&
        focusWasLost
      ) {
        trigger.focus({preventScroll: true});
      }
    }, 350);
  });

  /*
   * Gift-with-purchase apps can ask Broadcast to defer its normal cart
   * refresh. In that branch Broadcast emits theme:cart:change without a
   * cartCount, which otherwise leaves the header quantity badge unchanged.
   * Read Shopify's authoritative cart count and re-emit the completed event.
   */
  var cartCountRefreshTimer;
  document.addEventListener('theme:cart:change', function(event) {
    if (event.detail && Number.isFinite(Number(event.detail.cartCount))) {
      return;
    }

    window.clearTimeout(cartCountRefreshTimer);
    cartCountRefreshTimer = window.setTimeout(function() {
      fetch(window.theme.routes.cart_url + '.js', {
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Cart count refresh failed');
          }
          return response.json();
        })
        .then(function(cart) {
          document.dispatchEvent(
            new CustomEvent('theme:cart:change', {
              bubbles: true,
              detail: {
                cartCount: cart.item_count,
                source: 'admiral-row-cart-count-sync'
              }
            })
          );
        })
        .catch(function() {
          /*
           * The cart remains usable if a transient request fails. Broadcast's
           * next standard cart refresh or a page navigation will reconcile it.
           */
        });
    }, 100);
  });

  /*
   * Predictive-search options are the destination links themselves so a
   * listbox option never contains a second interactive element. Broadcast's
   * Arrow-key selection continues to set aria-selected on each option; this
   * capture handler preserves Enter activation for the selected link.
   */
  document.addEventListener(
    'keydown',
    function(event) {
      if (event.key !== 'Enter' || !(event.target instanceof Element)) {
        return;
      }

      var predictiveSearch = event.target.closest('predictive-search');
      var selectedLink =
        predictiveSearch &&
        predictiveSearch.querySelector(
          'a[role="option"][aria-selected="true"]'
        );

      if (!selectedLink) {
        return;
      }

      event.preventDefault();
      selectedLink.click();
    },
    true
  );

  /*
   * Keep Broadcast's subtotal as the merchandise subtotal, then show a
   * separate estimated total that includes Route only while protection is
   * selected. Route remains the source of truth for both its live quote and
   * opt-in state.
   */
  class RouteCartEstimatedTotal extends HTMLElement {
    connectedCallback() {
      this.price = this.querySelector('[data-route-estimated-total-price]');
      this.cartForm = this.closest('[data-cart-form]');
      this.routeMount =
        this.cartForm &&
        this.cartForm.querySelector('[data-route-cart-protection]');
      this.update = this.update.bind(this);
      this.scheduleUpdate = this.scheduleUpdate.bind(this);

      if (this.routeMount) {
        this.routeObserver = new MutationObserver(this.scheduleUpdate);
        this.routeObserver.observe(this.routeMount, {
          attributes: true,
          attributeFilter: ['quote', 'status'],
          childList: true,
          subtree: true
        });
      }

      document.addEventListener('theme:cart:change', this.scheduleUpdate);
      document.addEventListener('theme:cart-drawer:open', this.scheduleUpdate);
      this.scheduleUpdate();
    }

    disconnectedCallback() {
      this.routeObserver && this.routeObserver.disconnect();
      document.removeEventListener('theme:cart:change', this.scheduleUpdate);
      document.removeEventListener('theme:cart-drawer:open', this.scheduleUpdate);
      window.cancelAnimationFrame(this.updateFrame);
    }

    scheduleUpdate() {
      window.cancelAnimationFrame(this.updateFrame);
      this.updateFrame = window.requestAnimationFrame(this.update);
    }

    quoteToCents(quote) {
      var amount = Number(String(quote || '').replace(/[^0-9.-]/g, ''));
      return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
    }

    update() {
      var cartTotal = this.cartForm && this.cartForm.querySelector(
        '[data-cart-price-holder] [data-cart-total]'
      );
      var routeWidget =
        this.routeMount &&
        this.routeMount.querySelector('route-protect-widget');
      var subtotal = cartTotal
        ? Number(cartTotal.getAttribute('data-cart-total'))
        : NaN;

      if (
        !this.price ||
        !routeWidget ||
        !Number.isFinite(subtotal) ||
        !window.theme ||
        typeof window.theme.formatMoney !== 'function'
      ) {
        this.hidden = true;
        return;
      }

      var routeIsSelected = routeWidget.getAttribute('status') === 'true';
      var routeQuote = routeIsSelected
        ? this.quoteToCents(routeWidget.getAttribute('quote'))
        : 0;
      var estimatedTotal = subtotal + routeQuote;

      this.price.textContent =
        estimatedTotal === 0
          ? window.theme.strings.free
          : window.theme.formatMoney(
              estimatedTotal,
              window.theme.moneyWithCurrencyFormat
            );
      this.dataset.routeSelected = String(routeIsSelected);
      this.hidden = false;
    }
  }

  if (!customElements.get('route-cart-estimated-total')) {
    customElements.define(
      'route-cart-estimated-total',
      RouteCartEstimatedTotal
    );
  }

  /*
   * Judge.me currently returns two cards for the homepage featured carousel.
   * Complete the intended three-card editorial row with a real five-star
   * review from the store's public Judge.me review feed. Keeping this in the
   * theme avoids changing the app-wide featured-review selection used by the
   * live theme.
   */
  function repairHomepageReviewLinks(scope) {
    var fallbackLinks = scope.querySelectorAll(
      'a[href="#judgeme_product_reviews"]'
    );

    fallbackLinks.forEach(function(link) {
      var visibleLabel = (link.textContent || '').replace(/\s+/g, ' ').trim();

      link.setAttribute('href', '/pages/reviews');
      link.setAttribute(
        'aria-label',
        visibleLabel
          ? visibleLabel + ' — Read all customer reviews'
          : 'Read all customer reviews'
      );
      link.setAttribute('data-ar-review-fallback', 'true');
    });
  }

  function addHomepageFeaturedReview() {
    if (!document.body.classList.contains('template-index')) {
      return false;
    }

    var itemWrapper = document.querySelector(
      '.jdgm-carousel__item-wrapper'
    );

    if (!itemWrapper) {
      return false;
    }

    repairHomepageReviewLinks(itemWrapper);

    if (
      itemWrapper.querySelector('[data-review-id="ar-featured-review-third"]')
    ) {
      return true;
    }

    var featuredItems = itemWrapper.querySelectorAll(
      '.jdgm-carousel-item'
    );

    if (featuredItems.length !== 2) {
      return featuredItems.length >= 3;
    }

    var thirdReview = document.createElement('div');
    thirdReview.className = 'jdgm-carousel-item';
    thirdReview.setAttribute('data-review-id', 'ar-featured-review-third');
    thirdReview.innerHTML =
      '<div class="jdgm-carousel-item__inner-wrapper">' +
        '<div class="jdgm-carousel-item__review">' +
          '<div class="jdgm-carousel-item__review-rating" tabindex="0" aria-label="5 stars" role="img">' +
            '<span class="jdgm-star jdgm--on"></span>' +
            '<span class="jdgm-star jdgm--on"></span>' +
            '<span class="jdgm-star jdgm--on"></span>' +
            '<span class="jdgm-star jdgm--on"></span>' +
            '<span class="jdgm-star jdgm--on"></span>' +
          '</div>' +
          '<div class="jdgm-carousel-item__review-content">' +
            '<div class="jdgm-carousel-item__review-title">Perfect</div>' +
            '<div class="jdgm-carousel-item__review-body"><p>I had been looking for a chain that doesn’t tarnish and goes with just about everything and this is it.</p></div>' +
          '</div>' +
        '</div>' +
        '<div class="jdgm-carousel-item__reviewer-name-wrapper">' +
          '<div class="jdgm-carousel-item__reviewer-name jdgm-ellipsis">Ashleigh G.</div>' +
          '<a class="jdgm-carousel-item__product jdgm-ellipsis" href="/products/chunky-flat-snake-chain-necklace#judgeme_product_reviews">' +
            '<div class="jdgm-carousel-item__product-title jdgm-ellipsis">Chunky Flat Snake Chain Necklace</div>' +
          '</a>' +
          '<div class="jdgm-carousel-item__timestamp jdgm-ellipsis" data-time="03/24/2026">03/24/2026</div>' +
        '</div>' +
      '</div>';

    itemWrapper.appendChild(thirdReview);
    repairHomepageReviewLinks(itemWrapper);
    return true;
  }

  if (!addHomepageFeaturedReview()) {
    var featuredReviewObserver = new MutationObserver(function() {
      if (addHomepageFeaturedReview()) {
        featuredReviewObserver.disconnect();
      }
    });

    featuredReviewObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    window.setTimeout(function() {
      featuredReviewObserver.disconnect();
    }, 10000);
  }


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
